<template>
  <div class="root">
    <div class="cells-wrapper">
      <cell class="cell" v-for="(cell, i) in cells" :key="i" :cell="cell" :style="{width: cellWidth + '%'}" />
    </div>
  </div>
</template>

<script>
import Cell from '@/components/game/Cell.vue';

export default {
  name: 'RenderArea',
  components: {
    cell: Cell,
  },
  computed: {
    cells() {
      return this.$store.state.game.cells;
    },
    cellWidth() {
      return 100 / Object.keys(this.cells).length + 0.1;
    },
  },
};
</script>

<style scoped lang="scss">
.root {
  position: relative;
  height: 100%;
  width: 100%;
}

.cells-wrapper {
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
  height: 100%;
  width: 100%;
  background: linear-gradient(rgb(211, 237, 255), #fff);

  .cell {
    margin-left: -0.1%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/RenderArea.vue